// @generated by tools/codegen from packages/tokens/icons.json — do not edit by hand.
// Lucide 1.61.0 (ISC) icon font, subset to 164 icons
export type IconName = "hash" | "formula" | "rollup" | "calculate" | "sheet" | "freeze" | "fillDown" | "fillRight" | "lock" | "creditCard" | "receipt" | "hardDrive" | "at" | "bell" | "bellOff" | "search" | "plus" | "close" | "chevronRight" | "chevronLeft" | "chevronDown" | "sidebar" | "splitH" | "splitV" | "tabs" | "window" | "home" | "message" | "thread" | "reaction" | "emoji" | "attach" | "send" | "arrowUp" | "image" | "file" | "page" | "folder" | "board" | "table" | "calendar" | "list" | "check" | "checkCircle" | "more" | "settings" | "user" | "users" | "invite" | "agent" | "sparkles" | "external" | "shield" | "key" | "eye" | "eyeOff" | "huddle" | "video" | "mic" | "micOff" | "screenShare" | "pin" | "bookmark" | "edit" | "trash" | "copy" | "link" | "externalLink" | "star" | "archive" | "format" | "bold" | "italic" | "strike" | "code" | "quote" | "listNumbered" | "todo" | "inbox" | "globe" | "language" | "filter" | "sort" | "drag" | "reply" | "reload" | "clock" | "hourglass" | "alert" | "warning" | "offline" | "upload" | "download" | "sun" | "moon" | "signOut" | "monitor" | "arrowLeft" | "arrowRight" | "arrowDown" | "mail" | "text" | "select" | "multiSelect" | "status" | "checkbox" | "relation" | "createdBy" | "properties" | "group" | "peek" | "expand" | "tag" | "grip" | "chevronUp" | "inProgress" | "square" | "heading1" | "heading2" | "heading3" | "divider" | "toggle" | "callout" | "starOff" | "priority" | "pagePlus" | "database" | "pageLink" | "notes" | "cloud" | "videoOff" | "screenShareOff" | "hand" | "leave" | "speaker" | "waveform" | "blur" | "fileImage" | "fileVideo" | "fileAudio" | "fileText" | "fileSpreadsheet" | "filePresentation" | "fileArchive" | "fileCode" | "fileExecutable" | "play" | "ban" | "sticker" | "location" | "booking" | "share" | "calendarCheck" | "phone" | "pause" | "help" | "lifebuoy" | "megaphone" | "keyboard" | "bug" | "feedback" | "contacts" | "zoomIn" | "zoomOut";
/** Glyph (private-use codepoint) per icon in the BundleIcons font. Render with class "b-icon". */
export const iconGlyphs = {
  hash: "\u{E0EF}",
  formula: "\u{E22D}",
  rollup: "\u{E201}",
  calculate: "\u{E1BC}",
  sheet: "\u{E157}",
  freeze: "\u{E165}",
  fillDown: "\u{E455}",
  fillRight: "\u{E459}",
  lock: "\u{E10B}",
  creditCard: "\u{E0AA}",
  receipt: "\u{E3D3}",
  hardDrive: "\u{E0ED}",
  at: "\u{E04E}",
  bell: "\u{E059}",
  bellOff: "\u{E05A}",
  search: "\u{E151}",
  plus: "\u{E13D}",
  close: "\u{E1B2}",
  chevronRight: "\u{E06F}",
  chevronLeft: "\u{E06E}",
  chevronDown: "\u{E06D}",
  sidebar: "\u{E12A}",
  splitH: "\u{E098}",
  splitV: "\u{E439}",
  tabs: "\u{E529}",
  window: "\u{E426}",
  home: "\u{E0F5}",
  message: "\u{E117}",
  thread: "\u{E40D}",
  reaction: "\u{E301}",
  emoji: "\u{E164}",
  attach: "\u{E12D}",
  send: "\u{E04A}",
  arrowUp: "\u{E04A}",
  image: "\u{E0F6}",
  file: "\u{E0C0}",
  page: "\u{E0CC}",
  folder: "\u{E0D7}",
  board: "\u{E170}",
  table: "\u{E17D}",
  calendar: "\u{E063}",
  list: "\u{E106}",
  check: "\u{E06C}",
  checkCircle: "\u{E226}",
  more: "\u{E0B6}",
  settings: "\u{E154}",
  user: "\u{E19F}",
  users: "\u{E1A4}",
  invite: "\u{E1A2}",
  agent: "\u{E1BB}",
  sparkles: "\u{E412}",
  external: "\u{E290}",
  shield: "\u{E158}",
  key: "\u{E0FD}",
  eye: "\u{E0BA}",
  eyeOff: "\u{E0BB}",
  huddle: "\u{E0F1}",
  video: "\u{E1A5}",
  mic: "\u{E118}",
  micOff: "\u{E119}",
  screenShare: "\u{E14F}",
  pin: "\u{E259}",
  bookmark: "\u{E060}",
  edit: "\u{E1F9}",
  trash: "\u{E18E}",
  copy: "\u{E09E}",
  link: "\u{E102}",
  externalLink: "\u{E0B9}",
  star: "\u{E176}",
  archive: "\u{E041}",
  format: "\u{E198}",
  bold: "\u{E05D}",
  italic: "\u{E0FB}",
  strike: "\u{E177}",
  code: "\u{E093}",
  quote: "\u{E239}",
  listNumbered: "\u{E1D1}",
  todo: "\u{E4C3}",
  inbox: "\u{E0F7}",
  globe: "\u{E0E8}",
  language: "\u{E0FE}",
  filter: "\u{E460}",
  sort: "\u{E37D}",
  drag: "\u{E0EB}",
  reply: "\u{E22A}",
  reload: "\u{E149}",
  clock: "\u{E087}",
  hourglass: "\u{E296}",
  alert: "\u{E077}",
  warning: "\u{E193}",
  offline: "\u{E1AF}",
  upload: "\u{E19E}",
  download: "\u{E0B2}",
  sun: "\u{E178}",
  moon: "\u{E11E}",
  signOut: "\u{E10E}",
  monitor: "\u{E11D}",
  arrowLeft: "\u{E048}",
  arrowRight: "\u{E049}",
  arrowDown: "\u{E042}",
  mail: "\u{E10F}",
  text: "\u{E185}",
  select: "\u{E4DD}",
  multiSelect: "\u{E35C}",
  status: "\u{E4B0}",
  checkbox: "\u{E559}",
  relation: "\u{E04D}",
  createdBy: "\u{E461}",
  properties: "\u{E29A}",
  group: "\u{E464}",
  peek: "\u{E431}",
  expand: "\u{E113}",
  tag: "\u{E17F}",
  grip: "\u{E0EA}",
  chevronUp: "\u{E070}",
  inProgress: "\u{E345}",
  square: "\u{E167}",
  heading1: "\u{E385}",
  heading2: "\u{E386}",
  heading3: "\u{E387}",
  divider: "\u{E11C}",
  toggle: "\u{E59B}",
  callout: "\u{E1C2}",
  starOff: "\u{E2B0}",
  priority: "\u{E1E3}",
  pagePlus: "\u{E0C9}",
  database: "\u{E0AD}",
  pageLink: "\u{E327}",
  notes: "\u{E596}",
  cloud: "\u{E088}",
  videoOff: "\u{E1A6}",
  screenShareOff: "\u{E150}",
  hand: "\u{E1D7}",
  leave: "\u{E138}",
  speaker: "\u{E1AB}",
  waveform: "\u{E55B}",
  blur: "\u{E040}",
  fileImage: "\u{E31C}",
  fileVideo: "\u{E321}",
  fileAudio: "\u{E31A}",
  fileText: "\u{E0CC}",
  fileSpreadsheet: "\u{E326}",
  filePresentation: "\u{E4AE}",
  fileArchive: "\u{E30D}",
  fileCode: "\u{E0C3}",
  fileExecutable: "\u{E328}",
  play: "\u{E13C}",
  ban: "\u{E051}",
  sticker: "\u{E302}",
  location: "\u{E111}",
  booking: "\u{E304}",
  share: "\u{E155}",
  calendarCheck: "\u{E2B7}",
  phone: "\u{E133}",
  pause: "\u{E12E}",
  help: "\u{E082}",
  lifebuoy: "\u{E101}",
  megaphone: "\u{E235}",
  keyboard: "\u{E284}",
  bug: "\u{E20C}",
  feedback: "\u{E56F}",
  contacts: "\u{E54D}",
  zoomIn: "\u{E1B6}",
  zoomOut: "\u{E1B7}",
} as const satisfies Record<IconName, string>;
